// config.js
// apiUrl sans slash final pour éviter "//" dans les URLs (ex. apiUrl + "/comptes/...")

const config = {
  development: {
    apiUrl: "http://127.0.0.1:8000",
    client: "http://localhost:3000",
    clientAdmin: "http://localhost:3001",
  },
  production: {
    apiUrl: "https://api.hometeacher.cg",
    client: "https://hometeacher.cg",
    clientAdmin: "https://dashboard.hometeacher.cg",
  },
};

const environment = process.env.NODE_ENV || "development";
const envConfig = config[environment];
// Garantir une seule barre entre apiUrl et le chemin
if (envConfig && envConfig.apiUrl) {
  envConfig.apiUrl = envConfig.apiUrl.replace(/\/+$/, "");
}
module.exports = envConfig;
